import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {fontSizes, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Style.
 */

const StyledSubtitleDiv = styled.div`
  flex-grow: 1;
  margin-right: 8px;
  margin-top: 5px;

  font-size: ${fontSizes.verySmall};
  line-height: 16px;
  font-weight: ${fontWeights.normal};
  color: ${(p) => p.theme.greys.shade90};
`;

/*
 * Component.
 */

export const ComposerInfoBannerSubtitle: FC<PropsWithChildren<unknown>> = (props) => (
  <StyledSubtitleDiv>{props.children}</StyledSubtitleDiv>
);
